export default "__VITE_ASSET__tzfXgCkd__"